import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditEmployeePayScaleReady} from '../redux/employee_pay_scales'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

import {Employees,Reasons,EntityType,Designations} from '../../../common/DropDowns/index'

import DateTimeField from "react-bootstrap-datetimepicker";

//import moment from 'moment'

import * as Helpers from '../../../common/helpers'



function filterUnwantedData(employeeData) {
    let data = {}
    if (employeeData && employeeData.data && employeeData.data) {
        data = employeeData.data
    }

    let newData = {}
            newData.id = data.id ? data.id : ""
            newData.name = data.name ? data.name : ""
            newData.email = data.email ? data.email : ""
            newData.code = data.code ? data.code : ""
            newData.mobile = data.mobile ? data.mobile : ""
            newData.status = data.status ? data.status : ""
            newData.category = data.category ? data.category : ""
            newData.designation_id = data.designation_id ? data.designation_id : ""
            newData.status_class = data.status ? data.status.replace(" ","") : ""
            newData.city_name="NA"
            newData.work_location_type=data.work_location_type ? data.work_location_type : "NA"
            newData.work_location="NA"



            newData.designation_name = data.designation && data.designation.name ? data.designation.name : ""


            if(data.city && data.city.name){
                newData.city_name=data.city.name
            }

            if(data.kitchen_work_location && data.kitchen_work_location.name && data.work_location_type==="Kitchen"){
                newData.work_location=data.kitchen_work_location.name
            }

            if(data.office_work_location && data.office_work_location.name && data.work_location_type!=="Kitchen"){
                newData.work_location=data.office_work_location.name
            }

            newData.last_working_day=""
            newData.attrition_flag=false
            if(data.employee_attritions.length>0){
                newData.attrition_flag=true
                for (var j = data.employee_attritions.length - 1; j >= 0; j--) {
                    if(newData.last_working_day===""){
                            newData.last_working_day=Helpers.getDateFormatForUTC(data.employee_attritions[j].last_working_day)
                    }else{
                        if(new Date(data.last_working_day)>new Date(data.employee_attritions[j].last_working_day)){
                            newData.last_working_day=Helpers.getDateFormatForUTC(data.employee_attritions[j].last_working_day)
                        }
                    }
                    
                }
            }
    
    return newData
}


class AddEditEmployeePayScale extends Component {

  constructor() {
    super()
    this.state = {

        promotionDaysGap:30,
        bodyHeight: "0px",

        employeeData:{},
        employeePayScaleSelectedId:{},

        remarks: "",
        category: "",
        reasonId:"",
        designationId:"",
        newEmployeeCode:"",
        approverId: "",
        showEmployeeData:false,
        newEmployeeCodeFlag:false,
        employeeId:"",

        promotedDate:Helpers.getDateTimeFormatForUTC(new Date()),
        endDate:Helpers.getDateFormatForUTC(new Date()),

        remarksErrorText: false,
        remarksErrorData: '',

        changeType:"",

        categoryErrorText: false,
        categoryErrorData: '',

        employeeIdErrorText: false,
        employeeIdErrorData: '',

        approverIdErrorText: false,
        approverIdErrorData: '',

        reasonIdErrorText: false,
        reasonIdErrorData: '',

        designationIdErrorText: false,
        designationIdErrorData: '',

        newEmployeeCodeErrorText: false,
        newEmployeeCodeErrorData: '',

        
        subTitle: Constants.ADD_EMPLOYEE_PAY_SCALE

    }

    this.isComponentStillMounted = true

    this.remarksComponent = null
    this.remarksSection = null

    this.categoryComponent = null
    this.categorySection = null

    this.employeeIdComponent = null
    this.employeeIdSection = null


    this.approverIdComponent = null
    this.approverIdSection = null

    this.reasonIdComponent = null
    this.reasonIdSection = null

    this.designationIdComponent = null
    this.designationIdSection = null

    

    this.newEmployeeCodeComponent = null
    this.newEmployeeCodeSection = null
    

}

componentWillMount() {
    
    this.isComponentStillMounted = true
    this.props.dispatch(addEditEmployeePayScaleReady(true))
    
    this.props.dispatch(headerDataUpdate(Constants.ADD_EMPLOYEE_PAY_SCALE))    
    this.props.dispatch(subHeaderDataUpdate())

    this.setState({
            subTitle: "Promote Employee" 
    });
        
    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


}

componentDidMount() {

    
}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    let data = {}


    let employeeIdObject = this.mandateValidation("employeeId", Constants.FORM_SELECT)
    if (employeeIdObject.status) {
        data.employee_id = this.employeeIdComponent.value
    } else {
        return
    }


       if(new Date(this.state.promotedDate)<=new Date()){
                data.promoted_date= Helpers.getDateFormatForUTC(this.state.promotedDate)
            }else{
                this.dialog.show({
                        title: "Error!!",
                        body: "Promotion date should be less than or equals to current date",
                        actions: [
                                Dialog.OKAction(() => {
                            })
                        ],
                    })
            return
        }

        


    let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
    if (reasonIdObject.status) {
        data.reason_id = this.reasonIdComponent.value
    } else {
        return
    }

     data.employee={}

    if(data.reason_id==="121"){
            let designationIdObject = this.mandateValidation("designationId", Constants.FORM_SELECT)
            if (designationIdObject.status) {
                data.employee.designation_id = this.designationIdComponent.value
            } else {
                return
            }   

    }else if(data.reason_id==="122"){
            let categoryObject = this.mandateValidation("category", Constants.FORM_SELECT)
            if (categoryObject.status) {
                data.employee.category = this.categoryComponent.value
            } else {
                return
            } 

        if(this.state.newEmployeeCodeFlag){
            let newEmployeeCodeObject = this.mandateValidation("newEmployeeCode", Constants.FORM_INPUT)
            if (newEmployeeCodeObject.status) {
                data.employee.code = this.newEmployeeCodeComponent.value
            } else {
                return
            }
        }
    }
        
        

    let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
    if (remarksObject.status) {
        data.remarks = this.remarksComponent.value
    } else {
        return
    }

    data.code_at_promotion=this.state.employeeData.code



        let apiPayloadData=data;

        this.props.dispatch(addEditEmployeePayScaleReady(false))

        apiService.addEmployeePayScale(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditEmployeePayScaleReady(true))
                        this.props.history.goBack();
                    } else {

                        this.props.dispatch(addEditEmployeePayScaleReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditEmployeePayScaleReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}




getEmployeeById = (id) => {
    this.props.dispatch(addEditEmployeePayScaleReady(false))
    apiService.getEmployeeById(id)
        .then(responseData => {
            this.props.dispatch(addEditEmployeePayScaleReady(true))
            if (responseData.status === "SUCCESS") {
                if (responseData && responseData.data) {    
                      let filterData=filterUnwantedData(responseData)
                   
                    this.setState({
                        employeeData: filterData,
                        showEmployeeData:true
                        })


                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditEmployeePayScaleReady(true))
        })
}








promotedDateChange = (newDate) => {


    let promotedDate=Helpers.getDateTimeFormatForUTC(parseInt(newDate,10));

    this.setState({
        promotedDate: promotedDate
    });
}


endDateChange = (newDate) => {

    let endDate=Helpers.getDateTimeFormatForUTC(parseInt(newDate,10));

    this.setState({
        endDate: endDate
    });

}


 categoryChange = (data) => {
    this.categoryComponent.value=data.value
        this.setState({
            category :data.value,
            categoryErrorText: false,
            categoryErrorData: ''
        })
        this.categorySection.className= this.categorySection.className.replace(" has-error", "")


        if(data.value==="Permanent"){
            this.setState({
                newEmployeeCodeFlag:true 
            });
        }else{
            this.setState({
                newEmployeeCodeFlag:false 
            });
        }

        if(data.value===this.state.employeeData.category){
             this.dialog.show({
                            title: "Alert",
                            body: "Category should not be same as current category",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })

             this.setState({
                 newEmployeeCodeFlag:false 
             });
        }
    }





designationChange= (data) => {
    this.designationIdComponent.value=data.value
        this.setState({
            designationId :data.value,
            designationIdErrorText: false,
            designationIdErrorData: ''
        })
        this.designationIdSection.className= this.designationIdSection.className.replace(" has-error", "")



        if(parseInt(data.value,10)===parseInt(this.state.employeeData.designation_id,10)){
             this.dialog.show({
                            title: "Alert",
                            body: "Designation should not be same as current category",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
        }
    }

    employeeChange= (data) => {
    this.employeeIdComponent.value=data.value
        this.setState({
            employeeId :data.value,
            employeeIdErrorText: false,
            employeeIdErrorData: '',
            showEmployeeData:false
        })
        this.employeeIdSection.className= this.employeeIdSection.className.replace(" has-error", "")

        if(data.value!=="" && data.value!==undefined){
            this.setState({
                showEmployeeData:false 
            });
            this.getEmployeeById(data.value)
        }
    }




approverChange = (data) => {
    this.approverIdComponent.value=data.value
        this.setState({
            approverId :data.value,
            approverIdErrorText: false,
            approverIdErrorData: ''
        })
        this.approverIdSection.className= this.approverIdSection.className.replace(" has-error", "")
    }


 reasonChange = (data) => {
    this.reasonIdComponent.value=data.value
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            newEmployeeCodeFlag:false,
            category:"",
            reasonIdErrorData: ''
        })
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")

        if(data.value==="121"){
            this.setState({
                changeType:"Designation"
            });
        }else if(data.value==="122"){
            this.setState({
                changeType:"Category"
            });
        }else{
             this.setState({
                changeType:""
            });
        }
    }


    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        
                                            <div className="col-md-12 col-sm-12 col-xs-12" style={{zIndex:"4"}}>
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.employeeIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Employee *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.employeeIdComponent = el}>
                                                              <Employees type="" employeeChange={this.employeeChange} selectedValue={this.state.employeeId} />
                                                              <span className="help-block" style={{ display: this.state.employeeIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.employeeIdErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                     </div>                                          
                                                </div>

                                             {(() => {
                                                if(this.state.showEmployeeData || this.state.editFlag){
                                                    return(

                                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <div className="box-header with-border">
                                                               <h3 className="box-title" style={{ fontWeight: 600 }}>Employee Details</h3>
                                                            </div>
                                                        
                                             <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: "1%"}}>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.code}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.email}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Mobile :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.mobile}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.city_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.work_location}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  

                                        

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className={"form-group employee_status_"+this.state.employeeData.status_class+""}>
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                                        <div className="col-sm-7">
                                                               <strong> {this.state.employeeData.status}</strong>
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                                 <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Designation :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.designation_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>


                                                 <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Category :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.category}
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                                </div>

                                                    </div>

                                                        )
                                                    }
                                            })()} 


                                          <div className="col-md-12 col-sm-12 col-xs-12">

                                                <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"2"}}>
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Promotion Date *</label>
                                                     <div className="col-sm-9">
                                                        <DateTimeField mode="date" inputFormat="DD-MMM-YYYY" dateTime={new Date(this.state.promotedDate)} onChange={this.promotedDateChange}/>
                                                     </div>
                                                  </div>
                                               </div>

                                            </div>



                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.reasonIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                    <div className="col-sm-9" ref={el => this.reasonIdComponent = el}>
                                                       
                                                    <Reasons reasonChange={this.reasonChange} selectedValue={this.state.reasonId} type="EMPLOYEE_PAY_SCALE" />
                                                        <span className="help-block"style={{display: this.state.reasonIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.reasonIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>




                                               {(() => {
                                                if(this.state.changeType==="Category"){
                                                    return(


                                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el => this.categorySection = el}>
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>New Category *</label>
                                                                <div className="col-sm-9" ref={el => this.categoryComponent = el}>
                                                                    
                                                                     <EntityType entityTypeChange={this.categoryChange} selectedValue={this.state.category} type="EMPLOYEE_CATEGORY" />

                                                                    <span className="help-block" style={{display: this.state.categoryErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                        {this.state.categoryErrorData}
                                                                    </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </div>



                                                   )
                                                    }
                                            })()} 


                                              {(() => {
                                                if(this.state.newEmployeeCodeFlag){
                                                    return(



                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group" ref={el =>
                                                         this.newEmployeeCodeSection = el}>
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>New Employee ID *</label>
                                                         <div className="col-sm-9" >
                                                            <input className="form-control" placeholder="Enter New Employee id" type="number" ref={el => this.newEmployeeCodeComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("newEmployeeCode")}} />
                                                            <span className="help-block" style={{ display: this.state.newEmployeeCodeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.newEmployeeCodeErrorData}
                                                            </span>
                                                         </div>
                                                      </div>
                                                   </div>
                                                   </div>


                                                   )
                                                    }
                                             })()} 


                                                 

                                              {(() => {
                                                if(this.state.changeType==="Designation"){
                                                    return(

                                                     <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group" ref={el =>
                                                               this.designationIdSection = el}>
                                                               <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>New Designation *</label>
                                                               <div className="col-sm-9" ref={el =>
                                                                  this.designationIdComponent = el}>
                                                                  <Designations designationChange={this.designationChange} selectedValue={this.state.designationId} />
                                                                  <span className="help-block" style={{ display: this.state.designationIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                  {this.state.designationIdErrorData}
                                                                  </span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                        </div>


                                                     )
                                                    }
                                            })()} 


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" style={{resize: "none"}} placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>



                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Promote
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        employee_pay_scales: state.employee_pay_scales,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditEmployeePayScale))


// WEBPACK FOOTER //
// ./src/modules/Employee Pay Scales/Components/AddEditEmployeePayScale.js